export default __webpack_public_path__ + "static/screenshot1-fab649f6c3069207fe0422bbbc2d1439.jpg";